module.exports = (s) ->
  s
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/'/g, '&#39;')



// WEBPACK FOOTER //
// ./app/scripts/lib/util/text/html-encode.coffee